<template>
  <div class="pravo">
    <PravoTop Image="setCampaigns" Header="Set campaigns" />

    <div class="pravo__obsah">
      <div class="pravo__buttons">
        <router-link to="/game/SetCampaigns">
          <div class="pravo__buttons__goBack">
            <div class="pravo__buttons__goBack__icon setCampaigns"></div>
            <div class="pravo__buttons__goBack__text">Set campaigns</div>
          </div>
        </router-link>
      </div>

      <div class="grid">
        <CampaignsTable :archived="true" />
      </div>
    </div>
  </div>
</template>

<script>
import PravoTop from "@/components/game/pravo/PravoTop.vue";
import CampaignsTable from "@/components/game/table/tables/CampaignsTable.vue";

export default {
  name: "SetCampaigns",
  components: {
    PravoTop,
    CampaignsTable,
  },
};
</script>
